import SmartAddress from './SmartAddress';

export default SmartAddress;
